import { render, staticRenderFns } from "./Seguimiento.vue?vue&type=template&id=023733f1&lang=pug"
import script from "./Seguimiento.vue?vue&type=script&lang=js"
export * from "./Seguimiento.vue?vue&type=script&lang=js"
import style0 from "./Seguimiento.vue?vue&type=style&index=0&id=023733f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports